<template>
  <div>
        <span @dblclick="show" v-show="!show_form" style="cursor:pointer">
            {{ history.is_included_vat ? trans('with_vat') : trans('no_vat') }}
        </span>

    <div v-show="show_form">
      <select class="form-control" v-model="edited_is_included_vat">
        <option :value="1">{{ trans('with_vat') }}</option>
        <option :value="0">{{ trans('no_vat') }}</option>
      </select>
      <button @click="updateHistory"
              class="btn btn-primary"
              v-text="trans('update_button', null)"
      ></button>
    </div>
  </div>
</template>

<script>
let Functions = require("../../Functions");

export default {
    props: ['history', 'current_route', 'translations'],
    data: function () {
      return {
        'show_form': false,
        'edited_is_included_vat': this.history.is_included_vat ? 1 : 0,
      };
    },
    mounted: function () {
      Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
    },
    methods: {
      trans(name, path = 'stock') {
        return Functions.trans(this.translations, name, path);
      },
      show: function () {
        if(!this.history.is_verification) {
          return;
        }
        this.show_form = true;
      },
      updateHistory: function () {
        this.$http.post(this.current_route + '/update_history', {
          id: this.history.id,
          is_included_vat: this.edited_is_included_vat
        }).then(() => {
          this.show_form = false;
          this.$root.$emit('update-table');
        });
      },
    },
}
</script>
